import React from 'react';

import styled from 'styled-components';

import ObjectHistory from '@components/CreatedBy/ObjectHistory';
import { NwButton } from '@components/Gui/NwButton';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import NwIcon from '@components/Gui/NwIcon';
import { NwTag } from '@components/Gui/NwTag';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    && .ant-card {
        margin: 0 0 0.5rem 0;
    }

    && .ant-card-head {
        padding: 0 0.75rem 0 1rem;
    }

    && .ant-card-head-title {
        padding: 0.4rem 0;
    }

    && .ant-card-extra {
        padding: 0;
    }

    /* Il titolo e' un elemento custom: deve occupare tutta la riga. Le regole dell'header
       di NwCard sono molto annidate, per titolo e tag dell'ID serve !important */
    && .nw-card-head-title-content {
        flex: 1;
        min-width: 0;

        h1 {
            min-width: 0;
            text-transform: none !important;
        }

        small {
            font-size: 0.8rem !important;
            margin: 0 !important;
        }
    }

    && .ant-card-body-content {
        padding: 1.25rem 1.5rem;
    }
`;

const CardTitle = styled.div`
    align-items: center;
    display: flex;
    gap: 0.4rem;
    min-width: 0;

    .content-title-button {
        appearance: none;
        background: transparent;
        border: 0;
        color: inherit;
        cursor: pointer;
        font: inherit;
        overflow: hidden;
        padding: 0;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;

        &:hover {
            text-decoration: underline;
        }
    }
`;

const CardBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;

    /* le informazioni sono affiancate su due colonne di pari larghezza */
    .content-columns {
        display: grid;
        gap: 0.4rem;
        grid-template-columns: 1fr 1fr;
    }

    .content-row {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 0.4rem;
    }

    .content-row-label {
        color: ${(props) => props.theme.TextColorMuted};
        font-size: ${(props) => props.theme.FontSizeSm};
        text-transform: uppercase;
    }

    .content-published {
        font-size: ${(props) => props.theme.FontSizeSm};
        text-transform: uppercase;

        &.published {
            font-weight: bold;
        }

        &.not-published {
            color: ${(props) => props.theme.DangerColor};
        }
    }
`;

const getHistoryObject = (content) => ({
    DateCreated: content.CreatedAt,
    UserCreated: content.UserCreated,
});

const ModelContentItem = ({ canManageContent, content, tags, onDelete, onOpen, onTogglePublished }) => {
    const actions = [
        {
            name: '',
            key: 'edit',
            pinned: true,
            icon: byPrefixAndName.fasl['pen'],
            action: () => onOpen('edit'),
        },
        {
            name: 'delete',
            type: 'delete',
            key: 'delete',
            icon: byPrefixAndName.fasl['trash-alt'],
            confirmationPlacement: 'left',
            action: onDelete,
        },
    ];

    return (
        <Wrapper>
            <NwCard
                size="small"
                title={
                    <CardTitle>
                        <NwTag type="primary">{content.ID}</NwTag>
                        <h1>
                            <button className="content-title-button" type="button" onClick={() => onOpen('preview')}>
                                {content.Title || '—'}
                            </button>
                        </h1>
                    </CardTitle>
                }
                extra={canManageContent ? <NwDropDownMenu size="small" actions={actions} /> : null}
            >
                <CardBody>
                    <div className="content-columns">
                        <div className="content-row">
                            <ObjectHistory muted object={getHistoryObject(content)} />
                        </div>
                        <div className="content-row">
                            <span className="content-row-label">tags:</span>
                            {tags.length > 0 ? (
                                tags.map((tag) => (
                                    <NwTag key={tag.ID || tag.Name} type="primary">
                                        {tag.Name}
                                    </NwTag>
                                ))
                            ) : (
                                <span className="content-row-label">-</span>
                            )}
                        </div>
                    </div>
                    <div className="content-columns">
                        <div className="content-row">
                            <NwIcon
                                icon={
                                    content.Published ? byPrefixAndName.fasl['eye'] : byPrefixAndName.fasl['eye-slash']
                                }
                                danger={!content.Published}
                            />
                            <span className={`content-published ${content.Published ? 'published' : 'not-published'}`}>
                                {content.Published ? 'published' : 'not published'}
                            </span>
                        </div>
                        <div className="content-row">
                            {canManageContent && (
                                <NwButton
                                    size="small"
                                    label={content.Published ? 'unpublish' : 'publish'}
                                    onClick={onTogglePublished}
                                />
                            )}
                        </div>
                    </div>
                </CardBody>
            </NwCard>
        </Wrapper>
    );
};

export default ModelContentItem;
